import { Box, Radio, Text, makeUclComponent } from '@rbilabs/universal-components';

import { Accordion, AccordionItem } from 'components/accordion';

export const RadioWrapper = Box.withConfig({
  width: 'full',
  borderTopWidth: '1px',
  borderStyle: 'solid',
  borderTopColor: Styles.color.grey.four,
});

export const CustomRadio = Radio.withConfig({
  width: 'full',
  flexDirection: 'row-reverse',
  paddingY: '$4',
  paddingX: '$4',
});

export const RadioLabel = Text.withConfig({
  flex: 1,
  focusable: true,
  fontSize: 'lg',
});

export const TransactionDateOptionWrapper = Box.withConfig({
  margin: 0,
});

export const StyledAccordion = makeUclComponent(Accordion).withConfig({
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: Styles.color.grey.four,
  borderRadius: Styles.borderRadius,
  backgroundColor: Styles.color.cardBackground,
});

export const StyledAccordionItem = makeUclComponent(AccordionItem).withConfig({
  _accordionActivatorButton: {
    // override paddigY and paddigX values
    paddingY: '$4',
    paddingX: '$4',
  },
  _listItemTitle: {
    fontFamily: 'body',
    fontWeight: 'bold',
  },
});
